import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ChangeEmailModel} from '../../models/change-email-model';

@Component({
  selector: 'app-change-email-dialog',
  templateUrl: './change-email-dialog.component.html',
  styleUrls: ['./change-email-dialog.component.css']
})
export class ChangeEmailDialogComponent implements OnInit {
  public title = 'Change e-mail address';
  public text = 'Enter the new e-mail address to send a confirmation link to the customer';



  public email: string;



  constructor(
    public dialogRef: MatDialogRef<ChangeEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {

    if (this.data != null) {

      if( this.data.title != null ) {
this.title = this.data.title;
}
      if( this.data.text != null ) {
this.text = this.data.text;
}
    }
  }

  onYesClick(): void {

    const model = new ChangeEmailModel();
    model.email = this.email;


    this.dialogRef.close(model);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
